import {getTasks} from "../api/task/getTasks";
import {getTaskByID} from "../api/task/getTaskByID";
import {getTechnologyGroupTasks} from "../api/task/getTechnologyGroupTasks";
import {getProjectIdsFromGroups} from "../utils/taskUtils";

export function setFilters(filters) {
    return function (dispatch) {
        dispatch({
            type: "SET_FILTERS",
            payload: filters,
        });
    };
}

export function setTaskFilterId(filterId) {
    return function (dispatch) {
        dispatch({
            type: "SET_TASK_FILTER_ID",
            payload: filterId,
        });
    };
}

export function setSearch(search) {
    return function (dispatch) {
        dispatch({
            type: "SET_SEARCH",
            payload: search,
        });
    };
}

export function setOpeningSearch(value) {
    return function (dispatch) {
        dispatch({
            type: "SET_OPENING_SEARCH",
            payload: value,
        });
    };
}

export function setAggregation(aggregation) {
    return function (dispatch) {
        dispatch({
            type: "SET_AGGREGATION",
            payload: aggregation,
        });
    };
}

export function setBookmarkSettingModal(show) {
    return function (dispatch) {
        dispatch({
            type: "SET_BOOKMARK_SETTING_MODAL",
            payload: show,
        });
    };
}

export function selectBookmark(bookmark) {
    return function (dispatch) {
        dispatch({
            type: "SELECT_BOOKMARK",
            payload: bookmark,
        });
    };
}

export function setSort(sort) {
    return function (dispatch) {
        dispatch({
            type: "SET_SORT",
            payload: sort,
        });
    };
}

export function getTasksAPI(
    {
        DtaPlanned,
        DtaPlannedFrom,
        DtaPlannedTo,
        IsOpened,
        IsDone,
        Title,
        AssignTo,
        Priority,
        EstimatedTime,
        Limit,
        Reversed,
        Category,
        forceFetch = false,
        signal = null,
        NextToken,
        SortBy,
        AuthorID,
        DtaModTime,
        DtaModTimeFrom,
        DtaModTimeTo,
        ProjID,
        Observers,
        Search,
        Projects = null,
        Involves,
        Status,
        IssueID,
    } = {},
    keepExisting = false,
    keepPage = false,
    setLoading = true,
    scroll = null
) {
    return function (dispatch) {
        dispatch({
            type: "GET_TASKS",
            payload: getTasks(
                {
                    DtaPlanned,
                    DtaPlannedFrom,
                    DtaPlannedTo,
                    IsOpened,
                    IsDone,
                    Title,
                    AssignTo,
                    Priority,
                    EstimatedTime,
                    Limit,
                    Reversed,
                    forceFetch,
                    signal,
                    NextToken,
                    Category,
                    SortBy,
                    AuthorID,
                    DtaModTime,
                    DtaModTimeFrom,
                    DtaModTimeTo,
                    Observers,
                    Search,
                    Involves,
                    Projects,
                    Status,
                    IssueID,
                },
                {FarmID: ProjID}
            ),
            meta: {
                keepExisting,
                keepPage,
                setLoading,
                scroll,
            },
        });
    };
}

export function getTasksWithReplace({
    DtaPlanned,
    DtaPlannedFrom,
    DtaPlannedTo,
    IsOpened,
    IsDone,
    Title,
    AssignTo,
    Priority,
    EstimatedTime,
    Limit,
    Reversed,
    Category,
    forceFetch = false,
    SortBy,
    AuthorID,
    Observers,
    FarmID,
    Involves,
    Status,
    Search,
    IssueID,
} = {}) {
    return function (dispatch) {
        dispatch({
            type: "GET_TASKS_WITH_REPLACE",
            payload: getTasks(
                {
                    DtaPlanned,
                    DtaPlannedFrom,
                    DtaPlannedTo,
                    IsOpened,
                    IsDone,
                    Title,
                    AssignTo,
                    Priority,
                    EstimatedTime,
                    Limit,
                    Reversed,
                    forceFetch,
                    Category,
                    SortBy,
                    AuthorID,
                    Observers,
                    Involves,
                    Status,
                    Search,
                    IssueID,
                },
                {FarmID}
            ),
            meta: {DtaPlanned, FarmID},
        });
    };
}

export function getGroupedTasks(
    generalFilters,
    groupNames,
    maxItems = 10,
    replace = true,
    isLoading = true,
    clearCurrent = true,
    signal
) {
    return function (dispatch) {
        const promises = groupNames.map((item) =>
            !item.selector
                ? getTasks(
                      {...generalFilters, ...item.filters, signal},
                      {FarmID: item.FarmID}
                  )
                : null
        );
        dispatch({
            type: "GET_GROUPED_TASKS",
            payload: Promise.all(promises),
            meta: {groupNames, maxItems, replace, isLoading, clearCurrent},
        });
    };
}

export function changeTaskMonth(month, year) {
    return function (dispatch) {
        dispatch({
            type: "CHANGE_TASK_MONTH_AND_YEAR",
            payload: {month, year},
        });
    };
}

export function setTaskLoading(loading) {
    return function (dispatch) {
        dispatch({
            type: "SET_TASK_LOADING",
            payload: loading,
        });
    };
}

export function setSelectedTaskStatus(status) {
    return function (dispatch) {
        dispatch({
            type: "CHANGE_STATUS_SELECTED_TASK",
            payload: status,
        });
    };
}

export function setTaskStatus(IssueID, Status) {
    return function (dispatch) {
        dispatch({
            type: "SET_TASK_STATUS",
            payload: Status,
            meta: {IssueID},
        });
    };
}

export function clearTasks() {
    return function (dispatch) {
        dispatch({
            type: "CLEAR_TASKS",
        });
    };
}

export function addTaskAction(task) {
    return function (dispatch) {
        dispatch({
            type: "ADD_TASK",
            payload: task,
        });
    };
}

export function removeTaskAction(issueID) {
    return function (dispatch) {
        dispatch({
            type: "REMOVE_TASK",
            payload: issueID,
        });
    };
}

export function editTask(task, changeFarmID = false) {
    return function (dispatch) {
        dispatch({
            type: "EDIT_TASK",
            payload: task,
            meta: {changeFarmID},
        });
    };
}

export function getTaskToDrawerAPI({IssueID, FarmID} = {}) {
    return function (dispatch) {
        dispatch({
            type: "GET_TASK_TO_DRAWER",
            payload: getTaskByID({IssueID}, {FarmID}),
            meta: {IssueID},
        });
    };
}

export function addTaskComment(comment, issueID, date = +new Date()) {
    return function (dispatch, getState) {
        let state = getState();
        const LocalUserID = state.user.user.LocalUserID;
        dispatch({
            type: "ADD_TASK_COMMENT",
            payload: {Text: comment, Date: date, LocalUserID},
            meta: {issueID},
        });
    };
}

export function setTaskCommentFiles(issueID, date, files) {
    return function (dispatch) {
        dispatch({
            type: "SET_TASK_COMMENT_FILES",
            payload: {Date: date, Files: files},
            meta: {issueID},
        });
    };
}

export function removeTaskComment(issueID, index) {
    return function (dispatch) {
        dispatch({
            type: "REMOVE_TASK_COMMENT",
            payload: {index},
            meta: {issueID},
        });
    };
}

export function editTaskComment(issueID, index, comment) {
    return function (dispatch) {
        dispatch({
            type: "EDIT_TASK_COMMENT",
            payload: {index, comment},
            meta: {issueID},
        });
    };
}

export function addTemporaryTask(task) {
    return function (dispatch) {
        dispatch({
            type: "ADD_TEMPORARY_TASK",
            payload: task,
        });
    };
}

export function removeTaskFromList(id) {
    return function (dispatch) {
        dispatch({
            type: "REMOVE_TASK_FROM_LIST",
            payload: {id},
        });
    };
}

export function startTaskFileUpload(FileID, size, IssueID, file) {
    return function (dispatch) {
        dispatch({
            type: "START_TASK_FILE_UPLOAD",
            payload: {size, file},
            meta: {FileID, IssueID},
        });
    };
}

export function taskFileUploadProgress(FileID, loaded, IssueID) {
    return function (dispatch) {
        dispatch({
            type: "TASK_FILE_UPLOAD_PROGRESS",
            payload: {loaded},
            meta: {FileID, IssueID},
        });
    };
}

export function removeTaskUploadStatus(FileID, IssueID) {
    return function (dispatch) {
        dispatch({
            type: "TASK_FILE_UPLOAD_REMOVE",
            meta: {FileID, IssueID},
        });
    };
}

export function changeTaskGroupShowStatus(name) {
    return function (dispatch) {
        dispatch({
            type: "CHANGE_TASK_GROUP_SHOW_STATUS",
            payload: {name},
        });
    };
}

export function getDataAllProjects(projects, filters) {
    const Projects = getProjectIdsFromGroups(projects);
    return function (dispatch) {
        dispatch({
            type: "GET_TASKS_FOR_PROJECTS",
            payload: getTasks({
                ...filters,
                Projects,
            }),
        });
    };
}

export function getTasksForTechnologyGroup(start, FarmID) {
    return async function (dispatch) {
        const tasks = await getTechnologyGroupTasks(
            {GroupStartTime: start},
            {FarmID}
        );
        dispatch({
            type: "GET_TECHNOLOGYGROUP_TASKS_FULFILLED",
            payload: {Items: [...tasks]},
        });
    };
}

export function changeColorMethod(value) {
    return function (dispatch) {
        dispatch({
            type: "CHANGE_COLOR_METHOD",
            payload: value,
        });
    };
}

export function addTaskToDoItem(text, done, issueID) {
    return function (dispatch) {
        dispatch({
            type: "ADD_TASK_TO_DO_ITEM",
            payload: {Text: text, Done: done},
            meta: {issueID},
        });
    };
}

export function removeTaskToDoItem(text, issueID) {
    return function (dispatch) {
        dispatch({
            type: "REMOVE_TASK_TO_DO_ITEM",
            meta: {issueID, Text: text},
        });
    };
}

export function setToDoItemStatus(status, issueID, listID) {
    return function (dispatch) {
        dispatch({
            type: "SET_TO_DO_ITEM_STATUS",
            payload: {Done: status},
            meta: {issueID, listID},
        });
    };
}
